import styled from 'styled-components'
import Stars from 'learning/stars'

const ReviewPlaceholder = styled.div`
  .author-skeleton {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-block-end: 16px;
    &-name {
      width: 200px;
      height: 8px;
      background: var(--neutral70);
      margin-bottom: 4px;
    }
    &-photo {
      border-radius: 50%;
      width: 48px;
      height: 48px;
      background: var(--neutral70);
    }
    &-description {
      background: var(--neutral70);
      height: 10px;
      margin: 10px 0;
      &:nth-of-type(2) {
        width: 80%;
      }
      &:nth-of-type(3) {
        width: 70%;
      }
      &:nth-of-type(4) {
        width: 75%;
      }
      &:nth-of-type(5) {
        width: 40%;
      }
    }
  }
  .skeleton {
    background-image: linear-gradient(90deg, var(--neutral70), #ffffff90, var(--neutral70));
    background-size: 50px 100%;
    background-repeat: no-repeat;
    background-position: left -40px top 0;
    animation: shine 1s ease infinite;
    &:nth-of-type(1) {
      animation-duration: 0.8s;
    }
    &:nth-of-type(2) {
      animation-delay: 0.1s;
    }
    &:nth-of-type(3) {
      animation-delay: 0.2s;
    }
    &:nth-of-type(4) {
      animation-delay: 0.3s;
      animation-duration: 0.8s;
    }
  }
  @keyframes shine {
    to {
      background-position: right -40px top 0;
    }
  }
`

function ReviewsPlaceholder() {
  return (
    <>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
        <ReviewPlaceholder key={item}>
          <div className="author-skeleton">
            <div className="author-skeleton-photo skeleton" />
            <div>
              <p className="author-skeleton-name skeleton" />
              <Stars stars={5} size={16} gap={0} />
            </div>
          </div>
          <div className="author-skeleton-description skeleton" />
          <div className="author-skeleton-description skeleton" />
          <div className="author-skeleton-description skeleton" />
          <div className="author-skeleton-description skeleton" />
        </ReviewPlaceholder>
      ))}
    </>
  )
}

export default ReviewsPlaceholder
